import React from 'react';
import { Button } from 'reactstrap';
import { array, func, number } from 'prop-types';
import { currencyToSign } from '../../utils/utils';

const propTypes = {
  currencies: array.isRequired,
  onCurrencyChange: func.isRequired,
  active: number.isRequired,
};
const defaultProps = {
  currencies: [],
  active: 0
};

const StatisticsCurrenciesControl = ({ currencies, onCurrencyChange, active }) => (
  <div className='currencies'>
    {currencies.length > 0 &&
      currencies.map((currency, index) => (
        <Button
          className="currency-button"
          type="button"
          size="sm"
          color={index === active ? "primary" : "secondary"}
          onClick={() => onCurrencyChange(index)}
          key={currency}
        >
          {currency}, {currencyToSign(currency)}
        </Button>
      ))}
  </div>
);

StatisticsCurrenciesControl.propTypes = propTypes;
StatisticsCurrenciesControl.defaultProps = defaultProps;

export default StatisticsCurrenciesControl;
